<template>
    <div>

        <div v-if="init">

            <div class="flex justify-between mt-6">
                
                <div class="flex items-center">
                    <span>Filter by date:</span>
                    <input type="checkbox" class="mx-3" v-model="filterByDate">
                    <select class="form-input my-0" name="month" v-model="selectedMonth">
                        <option v-for="i in 12" :value="i - 1">{{ showMonthName(i - 1) }}</option>
                    </select>
                    <span class="inline-block mx-2">/</span>
                    <select class="form-input my-0" name="year" v-model="selectedYear">
                        <option v-for="i in yearSelect" :value="i">{{i}}</option>
                    </select>
                    <button @click="selectDate(-1)" class="btn btn-info ml-6" style="min-width: 2.8rem;">-</button>
                    <button @click="selectDate(1)" class="btn btn-info ml-6" style="min-width: 2.8rem;">+</button>
                </div>

				<div class="flex">
                    <div class="flex items-center">
                        <input id="all" name="filter" value="all" v-model="filter" type="radio" class="mr-1" />
                                        <label for="all">
                            <span class="mr-8">All</span>
                                        </label>
                        <input id="waiting" name="filter" value="waiting" v-model="filter" type="radio" class="mr-1" />
                        <label for="waiting">
                                            <span class="text-xs bg-orange-400 text-white p-1 rounded-md mr-8">Waiting</span>
                                        </label>
                        <input id="approved" name="filter" value="approved" v-model="filter" type="radio" class="mr-1" />
                        <label for="approved">
                                            <span class="text-xs bg-green-500 text-white p-1 rounded-md mr-8">Approved</span>
                                        </label>
                        <input id="declined" name="filter" value="declined" v-model="filter" type="radio" class="mr-1" />
                        <label for="declined">
                                            <span class="text-xs bg-red-500 text-white p-1 rounded-md mr-8">Declined</span>
                                        </label>
                    </div>
                    <div class="flex">
                        <Zondicon icon="search" class="w-4 mr-1 fill-current" />
                        <input v-model="searchUserQuery" class="form-input w-56" type="text" placeholder="Search user" />
                    </div>
                </div>
			</div>

            <div v-if="filteredVacations">

                <div style="max-height:72vh;" class="border border-gray-300 mb-12 mt-4 overflow-x-scroll" v-if="filteredVacations.length > 0">
                    <table class="table w-full">
                        <thead>
                            <tr>
                                <th style="top: -1px;" class="sticky z-20">Request ID</th>
                                <th style="top: -1px;" class="sticky z-20">Request date</th>
                                <th style="top: -1px;" class="sticky z-20">User</th>
                                <th style="top: -1px;" class="sticky z-20">From</th>
                                <th style="top: -1px;" class="sticky z-20">To</th>
                                <th style="top: -1px; width: 50px" class="sticky z-20">Hours</th>
                                <th style="top: -1px; width: 50px" class="sticky z-20">Days</th>
                                <th style="top: -1px;" class="sticky z-20">Comments</th>
                                <th style="top: -1px;" class="sticky z-20">
                                    <CellType>
                                        <template v-slot:type>Confirmed</template>
                                        <template v-slot:by>by team leader</template>
                                    </CellType>
                                </th>
                                <th style="top: -1px;" class="sticky z-20">
                                    <CellType>
                                        <template v-slot:type>Approved</template>
                                        <template v-slot:by>by manager</template>
                                    </CellType>
                                </th>
                                <th style="top: -1px;" class="sticky z-20">Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(vacation, index) in filteredVacations" :key="vacation._key">
                                <td>
                                    <div class="flex">
                                        <Zondicon icon="news-paper" class="w-4 mr-2 fill-current" />
                                        <span>Req #{{vacation._key.substring(0,3)}}</span>
                                    </div>
                                </td>
                                <td>{{ formatDate(vacation.requestedDate) }}</td>
                                <td>
                                    <div class="flex">
                                        <Zondicon icon="user" class="w-4 mr-4 fill-current" />
                                        <span>{{ getUserName(vacation.user) }}</span>
                                    </div>
                                </td>
                                <td>{{ formatDate(vacation.from) }}</td>
                                <td>{{ formatDate(vacation.to) }}</td>
                                <td class="font-bold" style="width: 50px">{{ vacation.hours }}</td>
                                <td class="font-bold" style="width: 50px">{{ getVacationDays(vacation.hours) }}</td>
                                <td>
                                    <span class="text-xs flex justify-between" v-if="vacation.comments">
                                        <span>
                                            <span>{{ vacation.comments.substr(0, 20) }}</span>
                                            <span v-if="vacation.comments.length > 20">...</span>
                                        </span>
                                        <span 
                                            class="underline cursor-pointer"
                                            v-if="vacation.comments.length > 20"
                                            @click="commentModal = true; comment = vacation.comments">
                                            show more
                                        </span>
                                    </span>
                                </td>

                                <td>

                                    <div v-if="isSubordinate(vacation.user)">
                                        <div v-if="vacation.confirmedDate">
                                            <div class="flex items-center leading-tight">
                                                <div
                                                    :class="{'bg-green-500': vacation.confirmed === true, 'bg-red-500': vacation.confirmed === false}"
                                                    class="w-2 h-2 rounded-full mr-2"></div>
                                                <div v-if="vacation.confirmed === true">confirmed</div>
                                            </div>
                                            <div class="leading-tight">
                                                <span class="text-gray-500 italic text-xs">{{ formatDate(vacation.confirmedDate, 1) }}</span>
                                            </div>
                                        </div>
                                        <div v-else>
                                            <div class="flex items-center leading-tight">
                                                <div class="w-2 h-2 bg-orange-400 rounded-full mr-2"></div>
                                                <div>pending</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-else>N/A</div>

                                </td>

                                <td>
                                    
                                    <div>
                                        <div v-if="!vacation.approvedDate">
                                            <div v-if="canAccess('canEditVacations')">
                                                <span
                                                    class="text-sm cursor-pointer bg-green-500 text-white px-2 py-1 rounded-md mr-1"
                                                    @click="showApprove = true; vacationKey = vacation._key">
                                                    Approve
                                                </span>
                                                <span
                                                    class="text-sm cursor-pointer bg-red-500 text-white px-2 py-1 rounded-md mr-1"
                                                    @click="showDecline = true; vacationKey = vacation._key">
                                                    Decline
                                                </span>
                                            </div>
                                            <div v-else>
                                                <div class="flex items-center leading-tight">
                                                    <div class="w-2 h-2 bg-orange-400 rounded-full mr-2"></div>
                                                    <div>pending</div>
                                                </div>
                                            </div>
                                        </div>
                                        <div v-if="vacation.approvedDate">
                                            <div class="flex items-center leading-tight">
                                                <div
                                                    :class="{'bg-green-500': vacation.approved === true, 'bg-red-500': vacation.approved === false}"
                                                    class="w-2 h-2 rounded-full mr-2"></div>
                                                <div v-if="vacation.approved === true">approved</div>
                                                <div v-if="vacation.approved === false">declined</div>
                                            </div>
                                            <div class="leading-tight">
                                                <span class="text-gray-500 italic text-xs">{{ formatDate(vacation.approvedDate, 1) }}</span>
                                            </div>
                                        </div>
                                    </div>

                                </td>

                                <td>
                                    <div class="flex">
                                        <router-link :to="{name: 'vacation-preview', params: {id: vacation._key}}" target="_blank" class="text-gray-600 cursor-pointer tooltip mr-4">
                                            <Zondicon icon="printer" class="w-4 fill-current" />
                                            <span class="tooltip-text -ml-4">Preview</span>
                                        </router-link>
                                        <div
                                            v-if="vacation.approvedDate && canAccess('canEditVacations')"
                                            class="text-gray-600 cursor-pointer mr-4 tooltip"
                                            @click="showUnlock = true; vacationKey = vacation._key">
                                            <Zondicon icon="key" class="w-4 fill-current" />
                                            <span class="tooltip-text -ml-4">Unlock</span>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>

                    <!-- <div class="flex justify-center py-4">
                        <button @click="loadMore()" class="text-sm cursor-pointer bg-gray-500 text-white px-2 py-1 rounded-md mr-1">load more</button>
                    </div> -->
                </div>

                <div v-else class="mb-12 mt-12">No vacation requests found! Please be patient and wait for some.</div>

            </div>

        </div>

        <div v-else class="loader loader-dark loader-big ml-4 mt-4 mr-0 mb-0"></div>

        <SimpleModal v-if="showApprove" @action="approveVacation(true, 'showApprove')" @close="showApprove = false" :btnClass="'btn-secondary'">
            <template v-slot:title>Approve this vacation request</template>
            <template v-slot:body>
                <span>Are you sure you want to approve this vacation request?</span><br>
                <span class="text-red-500" v-if="isPending">The team manager has not approved this vacation yet.</span>
            </template>
            <template v-slot:button>Approve</template>
        </SimpleModal>

        <SimpleModal v-if="showDecline" @action="approveVacation(false, 'showDecline')" @close="showDecline = false" :btnClass="'btn-danger'">
            <template v-slot:title>Decline this vacation request</template>
            <template v-slot:body>Are you sure you want to decline this vacation request?</template>
            <template v-slot:button>Decline</template>
        </SimpleModal>

        <SimpleModal v-if="commentModal" @close="commentModal = false" :btnClass="'btn-primary'" :doNotShowAction="true">
			<template v-slot:title>Vacation request comment</template>
			<template v-slot:body>{{ comment }}</template>
            <template v-slot:cancel>Close</template>
		</SimpleModal>

        <SimpleModal v-if="showUnlock" @action="unlockVacation()" @close="showUnlock = false" :btnClass="'btn-secondary'">
            <template v-slot:title>Unlock this vacation request</template>
            <template v-slot:body>Are you sure you want to unlock this vacation request?</template>
            <template v-slot:button>Unlock</template>
        </SimpleModal>

    </div>
</template>

<script>
import { db } from "@/firebase";
import { mapState } from "vuex";
import moment from "moment";
import helper from '../../helpers'
import removeDiacritis from 'diacritics';

import Zondicon from 'vue-zondicons';
import SimpleModal from '@/components/SimpleModal.vue'
import CellType from '@/components/CellType.vue'

export default {

    data() {
        return {
            allVacations: false,
            showApprove: false,
            showDecline: false,
            showUnlock: false,
            vacationKey: null,
            commentModal: false,
            comment: '',

            searchUserQuery: "",
            filter: "all",
            filterByDate: false,

            numOfItems: 50,

            date: {
                year: new Date().getFullYear(),
                month: new Date().getMonth()
            },
        }
    },

    computed: {
        init() {
            return this.allVacations && this.currentUser && this.users
        },

        selectedYear: {
            get() {
                return this.date.year
            },
            set(value) {
                var time = moment({
                    year: value,
                    month: this.selectedMonth
                })
                this.date.month = time.month()
                this.date.year = time.year()
            }
        },

        selectedMonth: {
            get() {
                return this.date.month
            },
            set(value) {
                var time = moment({
                    year: this.selectedYear,
                    month: value
                })
                this.date.month = time.month()
                this.date.year = time.year()
            }
        },

        yearSelect() {
            var yearArray = []
            for (var i = this.date.year - 5; i <= this.date.year + 3; i++) {
                yearArray.push(i)
            }
            return yearArray;
        },

        filteredVacations() {
            if (this.allVacations) {

                var filteredVacations = this.allVacations;


                filteredVacations = filteredVacations.filter(vacation => {
                    if (this.getUserName(vacation.user) !== 'superadmin') return 1
                })

                if (this.filterByDate) {
                    filteredVacations = filteredVacations.filter(vacation => {
                        var vacationFromDate = moment(vacation.from.seconds * 1000)
                        var selectedDate = moment({
                            year: this.date.year,
                            month: this.date.month
                        })
                        return vacationFromDate.isSame(selectedDate, 'month')
                    })
                }


                if (this.filter == 'approved') {
                    filteredVacations = filteredVacations.filter(vacation => vacation.approved)
                }

                if (this.filter == 'declined') {
                    filteredVacations = filteredVacations.filter(vacation => vacation.approved === false)
                }

                if (this.filter == 'waiting') {
                    filteredVacations = filteredVacations.filter(vacation => !vacation.approvedDate)
                }

                if (this.searchUserQuery.length > 0) {
                    filteredVacations = filteredVacations.filter(vacation => {
                        let username = this.getUserName(vacation.user);
                        username = username.toLowerCase()
                        username = removeDiacritis.remove(username);
                        return username.indexOf(this.searchUserQuery) > -1
                    })
                }


                filteredVacations = filteredVacations.sort((a, b) => {
                    return new Date(b.requestedDate.seconds * 1000) - new Date(a.requestedDate.seconds * 1000)
                })

                return filteredVacations;
            }
            return false
        },

        ...mapState({
			currentUser: state => state.user.info,
			users: state => state.users,
		}),

        isPending() {

            if (this.vacationKey) {
                var vacation = this.findVacation();
                if (!vacation.confirmedDate && this.isSubordinate(vacation.user)) return true;
            }

            return false;
        }
    },

    components: {
		SimpleModal,
		Zondicon,
        CellType
	},
    

    methods: {

        selectDate(add) {
            var time = moment({
                year: this.date.year,
                month: this.date.month
            })

            time.add(add, 'months')
            this.date.month = time.month()
            this.date.year = time.year()
        },

        showMonthName(i) {
            return moment({
                month: i
            }).format('MMMM')
        },

        loadMore() {
            this.numOfItems = this.numOfItems + 30
            this.getVacations()
        },

        canAccess(type) {
            return helper.canAccess(type, this.currentUser)
        },

        isSubordinate(uid) {
            return this.users.find(user => {
                if (user.subordinates.indexOf(uid) > -1 && user.role !== 'superadmin') return user
            })
        },

        getUserName(id) {
            if (this.users) {
                var user = this.users.find(user => user.uid === id);
                if (user) return user.name
                return ""
            }
            return ""
        },

        getVacationDays(hours) {
            var workingHours = (this.currentUser.isPartTime) ? this.currentUser.partTime : 8;
            return Math.round((hours/workingHours) * 10) / 10;
        },

        formatDate(date, hours) {
            var format = 'DD.MM.YYYY';
            if (hours) format += ' hh:mm';
            return moment(date.seconds * 1000).format(format);
        },

        findVacation() {
            if (this.allVacations) return this.allVacations.find(vacation => vacation._key === this.vacationKey);
        },

        getVacations() {
        
            db
            .collection('vacations')
            .orderBy('requestedDate', 'desc')
            // .limit(this.numOfItems)
            .onSnapshot(query => {
                var vacations = []
                query.forEach(function (doc) {
                    var vacation = doc.data()
                    vacation._key = doc.id
                    vacations.push(vacation)
                });
                this.allVacations = vacations
            })

        },

        approveVacation(state, modal) {

            var update = {
                approved: state,
                approvedDate: new Date(),
                approvedBy: this.currentUser.uid
            }

            if (this.isPending) {
                update.confirmed = true;
                update.confirmedDate = new Date();
                update.confirmedBy = this.currentUser.uid;
            }

            db
            .collection('vacations')
            .doc(this.vacationKey)
            .update(update)
            .then(() => {
                this[modal] = false
                this.$toasted.show(`Approved successfully!`, {
                    type: 'success'
                })
            })
            .catch(error => {
                this[modal] = false
                this.$toasted.show(`Error: ${error}`, {
                    type: 'error'
                })
            });
        },

        unlockVacation() {
            db
            .collection('vacations')
            .doc(this.vacationKey)
            .update({
                approved: null,
                approvedDate: null,
                approvedBy: null
            })
            .then(() => {
                this.showUnlock = false
                this.$toasted.show(`Unlocked successfully!`, {
                    type: 'success'
                })
            })
            .catch(error => {
                this.showUnlock = false
                this.$toasted.show(`Error: ${error}`, {
                    type: 'error'
                })
            });
        },

    },

    created() {

        var interval = setInterval(() => {
            if (this.currentUser) {
                this.getVacations()
                if (!this.users) this.$store.dispatch('getUsers')
                clearInterval(interval)
            }
        }, 100)

        this.$store.commit('SET_TITLE', 'Dashboard Vacations');
    }

}
</script>
